/**
 * Created by Daniel on 4/13/2021
 * ------ maintenance history ------
 * TODO: This component is tightly coupled with workflow, need to refactor later
 * Modified by Simon Zhao on 3/14/2022 disabled the menu items of adding gateways inside a gateway branch in order to avoiding the nested gateway configurations.
 * Updated by Daniel Wang on 5/31/2023, Added create a sidenote
 * Updated by Daniel Wang on 7/3/2023, Added update a note
 */

import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ContextMenuComponent, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { Subscription } from 'rxjs';
import { StoreQuerierService } from '../../../services/store-querier.service';
import { workflowAutomationSelector, workflowCurrentTasksSelector } from '../../../tamalelibs/redux/reducers/workflow.reducer';
import { AutomationActionType, DiagramContextMenu, DiagramContextMenuActionType, DiagramContextMenuEventType, TaskMenuItem } from './diagram-context-menu.model';
import { DiagramService } from '../diagram.service';
import { GatewayType, GatewayTypes, TaskTypes } from '../../../tamalelibs/models/workflow.model';
import { WorkflowConfigService } from '../../../tamalelibs/services/workflow-config.service';
import { AutomationModelBase } from '../../../tamalelibs/models/automation-base.model';

const AUTOMATION_SUBITEMS = [{ id: AutomationActionType.CreateANote.toString(), guid: AutomationActionType.CreateANote.toString(), name: 'workflow.create_a_note', enable: true },
{ id: AutomationActionType.CreateASidenote.toString(), guid: AutomationActionType.CreateASidenote.toString(), name: 'workflow.create_a_sidenote', enable: false },
{ id: AutomationActionType.UpdateANote.toString(), guid: AutomationActionType.UpdateANote.toString(), name: 'workflow.update_a_note', enable: false },
{ id: AutomationActionType.CreateRelationships.toString(), guid: AutomationActionType.CreateRelationships.toString(), name: 'workflow.create_relationships', enable: true },
{ id: AutomationActionType.CreateAnEntity.toString(), guid: AutomationActionType.CreateAnEntity.toString(), name: 'workflow.create_an_entity', enable: false },
{ id: AutomationActionType.UpdateAnEntity.toString(), guid: AutomationActionType.UpdateAnEntity.toString(), name: 'workflow.update_an_entity', enable: false }];

@Component({
    selector: 'tam-diagram-context-menu',
    templateUrl: './diagram-context-menu.component.html',
    styleUrls: ['./diagram-context-menu.component.scss']
})
export class DiagramContextMenuComponent implements OnInit, OnDestroy {

    automationSubMenuItems: Array<TaskMenuItem> = AUTOMATION_SUBITEMS;

    @Input() config: DiagramContextMenu;
    @ViewChild('taskActionMenu', { static: false }) menuEle: ContextMenuComponent<any>;
    /**
     * to store all the automation nodes in current workflow.
     */

    allAutomationNodes: Array<AutomationModelBase> = [];
    /**
     * to store all the tasks in current workflow.
     */
    currentAllTasks: Array<TaskMenuItem> = [];

    /**
     * a flag indicating whether current node is a gateway node.
     */
    isInsideGatewayNode = false;

    /**
     * a flag indicating whether current node and its parent node are both gateway nodes.
     */
    isGrandChildOfGatewayNode = false;

    /**
     * a flag indicating whether current node is a parallel gateway node.
     */
    isInsideParallelGateway = false;

    /**
     * gets a flag indicating whether the tamale automation menu item is enabled.
     */
    isTamaleAutomationEnabled = true;

    /**
     * gets a flag indicating whether the move item is enabled.
     */
    isMoveItemEnabled = true;

    /**
     * the id of the target node.
     */
    private _targetId;

    /**
     * the id of the target branch to append automations. It only means that the automation would be appended to the target node rather than the branch if it's null.
     */
    private _automationTargetBranchId: string;

    private _condition;

    private _destroySubscriptions: Array<Subscription> = [];
    /**
     * the id of the target branch to append task nodes. This is used for the case in which a successor of a gateway that is on a branch of its parent gateway is going to add, and the successor is essentionally added to this branch.
     */
    private _parentGatewayBranchID: string;
    constructor(
        private _contextMenuService: ContextMenuService<any>,
        private _changeDetectorRef: ChangeDetectorRef,
        private _storeQueriery: StoreQuerierService,
        private _diagramService: DiagramService,
        private _workflowConfigService: WorkflowConfigService
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(
            this.config.actions$.subscribe(((res) => {
                if (res.type === DiagramContextMenuActionType.CloseMenu) {
                    this.close();
                } else if (res.type === DiagramContextMenuActionType.LoadData) {
                    const triggerSetting = this._workflowConfigService.getWorkflowTriggerSettingConfig;
                    if (triggerSetting && triggerSetting.triggerMethod) {
                        const _isEnableNoteDeposit = triggerSetting.triggerMethod.noteDeposit;
                        this.automationSubMenuItems.forEach(item => {
                            if (item.id === AutomationActionType.CreateASidenote.toString() ||
                                item.id === AutomationActionType.UpdateANote.toString()) {
                                item.enable = _isEnableNoteDeposit;
                            }
                        });
                    }

                    const data = res.payload;
                    // init sub menu for move tasks
                    this.currentAllTasks = this._storeQueriery.queryBySelector(workflowCurrentTasksSelector);
                    // init sub menu for move automation nodes
                    this.allAutomationNodes = this._storeQueriery.queryBySelector(workflowAutomationSelector);
                    // used for node
                    this._targetId = data['targetId'];
                    // usually the branch id
                    this._condition = data['condition'];
                    this._parentGatewayBranchID = data['parentBranch'];
                    const isAddingGatewaySuccessor = data['isGatewaySuccessor'];
                    // disable the nodes
                    const disableNodeId = [];
                    const disableAutomationId = [];
                    if (this._targetId) {
                        disableNodeId.push(this._targetId);
                    }
                    const targetNode = this._diagramService.getNode(this._targetId);
                    this.isInsideGatewayNode = data.isAddToBranch;
                    this.isGrandChildOfGatewayNode = false;
                    if (data.isTriggerOnBranch) {
                        // only append the new automation to the branch when this action is triggered by the add button of a branch rather than any child of a branch.
                        this._automationTargetBranchId = this._condition;
                    } else {
                        this._automationTargetBranchId = null;
                    }

                    if (this.isInsideGatewayNode) {
                        // deterimine whether disable the gateway menu items by the target node's depth
                        // current way is to track the depth via each node's parentBranch, to which the target node belongs to.
                        if (targetNode && targetNode.parentBranchID) {
                            // target node's parent is on a branch
                            let depth = 1;
                            if (this._diagramService.isGatewayNode(targetNode) && !isAddingGatewaySuccessor) {
                                // adding on a gateway(target node)'s branch
                                // counting target node as the first level
                                depth++;
                            }

                            const parentGatewayNode = this._diagramService.getGatewayByBranchId(targetNode.parentBranchID);
                            if (parentGatewayNode && parentGatewayNode.parentBranchID) {
                                depth++;
                            }

                            if (depth > 1) {
                                // Disable gateway menus if calling up the menu on a node whose depth is greater than one.
                                this.isGrandChildOfGatewayNode = true;
                            }
                        }
                    }

                    if (targetNode) {
                        this.isInsideParallelGateway = targetNode.type && targetNode.type === GatewayType.PARALLEL && data.isTriggerOnBranch;
                        // task
                        if (GatewayTypes.indexOf(targetNode.type) > -1) {
                            targetNode.children.forEach(nodeId => {
                                const node = this._diagramService.getNode(nodeId);
                                if (node.condition === this._condition) {
                                    // the child node is on the given branch of the target node.
                                    disableNodeId.push(nodeId);
                                }
                            });
                        } else {
                            disableNodeId.push(Array.from(targetNode.children)[0]);
                        }

                        // automation
                        if (GatewayTypes.indexOf(targetNode.type) > -1) {
                            let isAutomationOnBranch = false;

                            targetNode.branchs.forEach(branch => {
                                if (branch.id === this._condition || branch.guid === this._condition) {
                                    isAutomationOnBranch = true;
                                }
                                if (branch.automationConfigs && branch.automationConfigs.length > 0) {
                                    branch.automationConfigs.forEach(automation => {
                                        if (automation.attachedNodeId === this._condition) {
                                            disableAutomationId.push(automation.id);
                                        }
                                    });
                                }
                            });
                            if (!isAutomationOnBranch) {
                                if (targetNode.automationConfigs && targetNode.automationConfigs.length > 0) {
                                    targetNode.automationConfigs.forEach(automation => {
                                        disableAutomationId.push(automation.id);
                                    });
                                }
                            }
                        } else {
                            if (targetNode.automationConfigs && targetNode.automationConfigs.length > 0) {
                                const maxNumber = targetNode.automationConfigs.length;
                                disableAutomationId.push(targetNode.automationConfigs.map(item => item.id)[maxNumber - 1]);
                            }
                        }
                    } else {
                        const nodesList = this._diagramService.serialize();
                        nodesList.forEach(item => {
                            if (TaskTypes.indexOf(item.type) > -1) {
                                if (Array.from(item.parents)[0] === 'Start') {
                                    disableNodeId.push(item.guid);
                                }
                            }
                        });
                    }
                    // set the task status on context menu named move
                    if (this.currentAllTasks) {
                        this.currentAllTasks.forEach(task => {
                            if (disableNodeId.includes(task.id) || disableNodeId.includes(task.guid)) {
                                task.enable = false;
                            } else {
                                task.enable = true;
                            }
                        });
                    }
                    // set the automation status on context menu named move
                    if (this.allAutomationNodes) {
                        this.allAutomationNodes.forEach(automation => {
                            if (disableAutomationId.includes(automation.id)) {
                                automation.enable = false;
                            } else {
                                automation.enable = true;
                            }
                        });
                    }

                    this.isTamaleAutomationEnabled = !!this._targetId && !this.isInsideParallelGateway;
                    this.isMoveItemEnabled = (this.currentAllTasks && this.currentAllTasks.length > 0);
                    this._changeDetectorRef.detectChanges();
                    // show context menu
                    this._contextMenuService.show(this.menuEle, { x: data['event'].clientX, y: data['event'].clientY });
                }
            }).bind(this)),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    addNode(nodeType) {
        this.config.events$.next({
            type: DiagramContextMenuEventType.nodeAdd,
            payload: {
                nodeType: nodeType,
                targetId: this._targetId,
                condition: this._condition,
                parentBranch: this._parentGatewayBranchID,
            }
        });
        this._condition = null;
    }

    addAutomation(action: TaskMenuItem) {
        switch (action.id) {
            case AutomationActionType.CreateANote.toString(): {
                this.config.events$.next({
                    type: DiagramContextMenuEventType.automationAdd,
                    payload: {
                        actionType: AutomationActionType.CreateANote,
                        targetId: this._automationTargetBranchId ? this._automationTargetBranchId : this._targetId
                    }
                });
                break;
            }
            case AutomationActionType.UpdateANote.toString(): {
                this.config.events$.next({
                    type: DiagramContextMenuEventType.automationAdd,
                    payload: {
                        actionType: AutomationActionType.UpdateANote,
                        targetId: this._automationTargetBranchId ? this._automationTargetBranchId : this._targetId
                    }
                });
                break;
            }
            case AutomationActionType.CreateASidenote.toString(): {
                this.config.events$.next({
                    type: DiagramContextMenuEventType.automationAdd,
                    payload: {
                        actionType: AutomationActionType.CreateASidenote,
                        targetId: this._automationTargetBranchId ? this._automationTargetBranchId : this._targetId
                    }
                });
                break;
            }
            case AutomationActionType.CreateRelationships.toString(): {
                this.config.events$.next({
                    type: DiagramContextMenuEventType.automationAdd,
                    payload: {
                        actionType: AutomationActionType.CreateRelationships,
                        targetId: this._automationTargetBranchId ? this._automationTargetBranchId : this._targetId
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    close() {
        // this._contextMenuService.closeAllContextMenus({ eventType: 'cancel' });
        this._contextMenuService.closeAll();
    }

    moveAutomationNode(automationNode: AutomationModelBase) {
        this.config.events$.next({
            type: DiagramContextMenuEventType.automationMove,
            payload: {
                targetId: this._targetId,
                condition: this._condition,
                moveAutomation: automationNode
            }
        });
    }

    moveTask(task) {
        this.config.events$.next({
            type: DiagramContextMenuEventType.nodeMove,
            payload: {
                targetId: this._targetId,
                condition: this._condition,
                moveTask: task
            }
        });
    }
}
